<script lang="ts">
    import { onMount } from 'svelte';
    import { push } from 'svelte-spa-router';
    import * as qs from 'qs';
    import configs from '../config';

    let appName = 'แอปพลิเคชัน'
    let logo = ''
    let deferredPrompt = null
    let canInstall = false
    let installed = false
    let isIOS = false
    let message = ''

    function injectManifest(){
        // ชี้ manifest ไป backend แบบ dynamic โดยส่ง host ของหน้านี้ (start_url/scope ต้อง same-origin)
        let link = document.querySelector('link[rel="manifest"]')
        if(!link){
            link = document.createElement('link')
            link.setAttribute('rel','manifest')
            document.head.appendChild(link)
        }
        link.setAttribute('href', configs.cloudapi+"/cloud/manifest?host="+encodeURIComponent(window.location.host))
        link.setAttribute('crossorigin','anonymous')
    }

    async function loadConfig(){
        try{
            const res = await fetch(configs.cloudapi+"/cloud/configs", {
                method: 'POST',
                headers:{ 'Content-Type': 'application/x-www-form-urlencoded' },
                body: qs.stringify({})
            })
            const json = await res.json()
            if(json.statusCode==200 && json.payload){
                appName = json.payload.title || appName
                logo = json.payload.logo || json.payload.logo_wallet || ''
            }
        }catch(err){ /* ignore */ }
    }

    async function registerSW(){
        if('serviceWorker' in navigator){
            try{ await navigator.serviceWorker.register('/sw.js') }catch(err){ /* ignore */ }
        }
    }

    async function doInstall(){
        if(!deferredPrompt){ return }
        deferredPrompt.prompt()
        const choice = await deferredPrompt.userChoice
        if(choice && choice.outcome === 'accepted'){
            installed = true
        }
        deferredPrompt = null
        canInstall = false
    }

    function isStandalone(){
        return window.matchMedia('(display-mode: standalone)').matches
            || window.matchMedia('(display-mode: fullscreen)').matches
            || window.matchMedia('(display-mode: minimal-ui)').matches
            || (window.navigator as any).standalone === true
    }

    onMount(() => {
        // เปิดจากแอปที่ติดตั้งแล้ว (standalone) → ไปหน้า dashboard เลย ไม่ต้องโชว์หน้าติดตั้ง
        if(isStandalone()){
            push('/dashboard')
            return
        }

        isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent)
        injectManifest()
        registerSW()
        loadConfig()

        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault()
            deferredPrompt = e
            canInstall = true
        })
        window.addEventListener('appinstalled', () => {
            installed = true
            canInstall = false
        })
    })
</script>

<svelte:head>
    <title>ติดตั้งแอป {appName}</title>
    <meta name="theme-color" content="#000000" />
    {#if logo}<link rel="apple-touch-icon" href={logo} />{/if}
</svelte:head>

<div class="pwa-wrap">
    <div class="pwa-card">
        {#if logo}
            <img class="pwa-logo" src={logo} alt={appName} />
        {/if}
        <h3 class="pwa-title">{appName}</h3>

        {#if installed}
            <p class="pwa-desc">ติดตั้งแอปเรียบร้อยแล้ว ✅<br>เปิดแอปจากหน้าจอโฮมได้เลย</p>
        {:else if isIOS}
            <p class="pwa-desc">วิธีติดตั้งบน iPhone / iPad:</p>
            <ol class="pwa-steps">
                <li>กดปุ่ม <b>แชร์</b> <span style="font-size:1.1rem;">􀈂</span> ด้านล่างของ Safari</li>
                <li>เลือก <b>เพิ่มไปยังหน้าจอโฮม</b> (Add to Home Screen)</li>
                <li>กด <b>เพิ่ม</b> มุมบนขวา</li>
            </ol>
        {:else if canInstall}
            <p class="pwa-desc">กดปุ่มด้านล่างเพื่อติดตั้งแอปลงเครื่องของคุณ</p>
            <button class="pwa-btn" on:click={doInstall}>📲 ติดตั้งแอป</button>
        {:else}
            <p class="pwa-desc">กำลังเตรียมการติดตั้ง...<br><small>ถ้าปุ่มไม่ขึ้น ให้เปิดหน้านี้บน Chrome และลองรีเฟรช</small></p>
        {/if}

        {#if message}<p class="pwa-msg">{message}</p>{/if}
    </div>
</div>

<style>
    .pwa-wrap{
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
    }
    .pwa-card{
        width: 100%;
        max-width: 360px;
        background: rgba(20,20,20,.85);
        border: 1px solid rgba(230,196,119,.4);
        border-radius: 14px;
        padding: 28px 22px;
        text-align: center;
        color: #fff;
        box-shadow: 0 8px 24px rgba(0,0,0,.5);
    }
    .pwa-logo{ max-width: 96px; max-height: 96px; border-radius: 18px; margin-bottom: 14px; }
    .pwa-title{ color: #e6c477; font-weight: 600; margin-bottom: 12px; }
    .pwa-desc{ font-size: .85rem; line-height: 1.6; }
    .pwa-steps{ text-align: left; font-size: .82rem; line-height: 1.8; margin-top: 10px; }
    .pwa-btn{
        margin-top: 16px;
        width: 100%;
        padding: 12px;
        border: none;
        border-radius: 10px;
        font-weight: 600;
        color: #1a1a1a;
        background: linear-gradient(135deg,#e6c477 0%,#f4e2b8 50%,#e6c477 100%);
        box-shadow: 0 3px 8px rgba(0,0,0,.4);
        cursor: pointer;
    }
    .pwa-msg{ margin-top: 12px; font-size: .8rem; color: #ffd; }
</style>
